module.exports = __webpack_public_path__ + "img/qrcode.3da6128b.png";